import { SplitScreenPage } from "@components/_auth/SplitScreenPage"
import { Signup } from "@components/_auth/signup"
import { GetServerSideProps } from "next"
import { NextPage } from "next"
import { BuiltInProviderType } from "next-auth/providers/index"
import {
  ClientSafeProvider,
  getProviders,
  getSession,
  LiteralUnion,
} from "next-auth/react"
import React from "react"
import Link from "next/link"

type SignupPageProps = {
  providers: Record<
    LiteralUnion<BuiltInProviderType, string>,
    ClientSafeProvider
  > | null
}

const SignupPage: NextPage<SignupPageProps> = ({ providers }) => {
  return (
    <SplitScreenPage
      title="Signup"
      description="Signup and unlock the full potential of Viesus Cloud"
      footerText={
        <>
          By signing up you agree to our{" "}
          <Link
            href="/terms-of-service"
            target="_blank"
            style={{ textDecoration: "underline" }}
          >
            Terms & Services
          </Link>{" "}
          and{" "}
          <Link
            href="/privacy-policy"
            target="_blank"
            style={{ textDecoration: "underline" }}
          >
            Privacy Statement
          </Link>
          .
        </>
      }
    >
      <Signup providers={providers} />
    </SplitScreenPage>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const session = await getSession({ req })
  const providers = await getProviders()
  if (session?.user) {
    return {
      redirect: {
        destination: "/app",
        permanent: false,
      },
    }
  }

  return {
    props: {
      providers,
    },
  }
}

export default SignupPage
